import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import {
  Button, DialogActions, DialogContent
} from '@material-ui/core';
import { translate } from 'utils';
import { ModalHeader } from './_ModalHeader';

export const ConfirmModal = ({
  onClose, onSubmit, text, title
}) => {
  const handleClose = useCallback(() => {
    if (onSubmit) { onSubmit(); }
    return onClose();
  }, [onSubmit, onClose]);

  return (
    <>
      <ModalHeader className="confirmModal">
        <FontAwesomeIcon icon={faCheckCircle} />
        {translate(title)}
      </ModalHeader>

      <DialogContent dangerouslySetInnerHTML={{ __html: text }} />

      <DialogActions>
        <Button
          variant="text"
          onClick={handleClose}
        >
          {translate('button.close')}
        </Button>
      </DialogActions>
    </>
  );
};

ConfirmModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({})
  ]),
  title: PropTypes.string
};

ConfirmModal.defaultProps = {
  onSubmit: null,
  text: '',
  title: 'confirms.actionSuccessful'
};